import { api } from '@/f1/service';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  props : ['user_id'],
  data: () => ({ so : default_opt() }),
  computed: {
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    en_fields() {
      return [
        { key: 'created_at', label: 'DateTime', sortable: false },
        { key: 'is_valid', label: 'Result', sortable: false },
        { key: 'addr', label: 'Address', sortable: false },
        { key: 'agent', label: 'Agent', sortable: false },
      ];
    },
    ko_fields() {
      return [
        { key: 'created_at', label: '시각', sortable: false },
        { key: 'is_valid', label: '응답', sortable: false },
        { key: 'addr', label: 'IP 주소', sortable: false },
        { key: 'agent', label: '요청 브라우저', sortable: false },
      ];
    },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'name,fqdn',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { target : 'log.login', cmd : 'list.user', limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // user
      if(this.user_id) { search.body.and.push({ name: 'user_id', op: '=', value : this.user_id }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: value, op: /%/.test(value) ? 'like' : '=' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value.trim().replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }
      try { let rs = await api.member.Manager(search); this.so.totalRows = rs.total; return rs.body; }
      catch(e) { this.$toastr.e(e.data || e); };
    },
    detail(item) {
      // this.$router.push(`/log.login/${item.id}`);
    },
  },
  created() { console.log('[vue] log.login', 'created'); },
  destroyed() { console.log('[vue] log.login', 'destroyed'); },
  mounted() { console.log('[vue] log.login', 'mounted'); },
}
